<script lang="ts">
    import Logo from "@components/material/Logo.svelte"
    import { fade } from "svelte/transition"
    export let message = ""
    export let opacity = 1
    export let duration = 1000
    export let wrapperID = ""
</script>

<div class="loader" id={wrapperID} transition:fade|global={{ duration }}>
    <div class="loader-container" style:opacity>
        <div class="loader-spinner">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>dots-anim-6</title><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="none" stroke="currentColor" stroke-miterlimit="10"><g class="nc-loop-dots-anim-6-48-icon-o"><circle cx="6" cy="24" r="4"></circle><circle cx="24" cy="24" r="4"></circle><circle cx="42" cy="24" r="4"></circle></g><style stroke-linecap="butt">.nc-loop-dots-anim-6-48-icon-o,.nc-loop-dots-anim-6-48-icon-o>*{--animation-duration:1.2s}.nc-loop-dots-anim-6-48-icon-o{transform-origin:50% 50%;animation:nc-loop-dots-anim-6 var(--animation-duration) infinite}.nc-loop-dots-anim-6-48-icon-o>:nth-child(2),.nc-loop-dots-anim-6-48-icon-o>:nth-child(3){transform-origin:33px 50%;animation:nc-loop-dots-anim-6-inner var(--animation-duration) infinite}@keyframes nc-loop-dots-anim-6{0%,50%{transform:rotate(0)}100%{animation-timing-function:cubic-bezier(1,0,0,1);transform:rotate(180deg)}}@keyframes nc-loop-dots-anim-6-inner{0%{transform:rotate(0)}100%,50%{animation-timing-function:cubic-bezier(1,0,0,1);transform:rotate(180deg)}}</style></g></svg> -->
            <Logo spinning={true} fading={true} />
        </div>
        <span class="translucent" style:text-align="center"
            >{@html message}</span
        >
    </div>
</div>

<style>
.loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loader-spinner {
  width: 50vw;
  max-width: 17em;
  color: var(--black);
  opacity: 0.5;
}
</style>
